import { useMutation } from '@tanstack/react-query'
import { Resume } from 'packages/types'
import { apiClient } from 'builder/modules/apiClient'

type Params<K extends keyof Resume> = {
  resume: Resume
  payload: { name: K; value: Resume[K] }
}

export const useUpdateResume = () => {
  async function apiCall<K extends keyof Resume>({ resume, payload }: Params<K>) {
    const { name, value } = payload
    const resumeData = { ...resume }
    resumeData[name] = value
    return apiClient.patch(`/resumes/${resume.id}`, resumeData)
  }

  return useMutation({ mutationFn: apiCall<keyof Resume> })
}
